import { useTranslation } from 'react-i18next';
import { selectedRoadSectionsQuery } from '../../../../../core/reference/queries';
import { useAppDispatch, useAppSelector } from '../../../../../types';
import { useEffect, useState } from 'react';
import { ContentContainer, ModalTitle } from '../../../../legacy/components/ui/modals/styles';
import GenericModal from '../../../../legacy/components/ui/modals/GenericModal';
import { ReferenceModalTypes } from '../../../../../core/legacy/reducers/modals';
import { Input } from '../../../../session/list-sessions/styles';
import editRoadSections from '../../../../../core/reference/commands/EditRoadSections';

const EditRoadSectionGestionaryModal = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const checkedRoadSections = useAppSelector(selectedRoadSectionsQuery);
    const checkedRoadSectionsIds = checkedRoadSections.map((s) => s.id);

    const [gestionaryName, setGestionaryName] = useState('');

    useEffect(() => {
        const gestionaryNames = checkedRoadSections
            .map((rs) => rs.gestionary)
            .filter((n) => n !== undefined)
            .reduce((acc, val) => acc.add(val!), new Set<string>());
        if (gestionaryNames.size === 1) {
            setGestionaryName(gestionaryNames.values().next().value as string);
        } else {
            setGestionaryName('');
        }
    }, [checkedRoadSections]);

    const onValidate = () => {
        dispatch(
            editRoadSections({
                roadSectionData: {
                    gestionary: gestionaryName,
                },
                roadSectionIds: checkedRoadSectionsIds,
            }),
        );
        setGestionaryName('');
    };

    const handleKeyDown = ({ key }: KeyboardEvent) => {
        if (key === 'Enter') {
            onValidate();
        }
    };

    return (
        <GenericModal
            onValidate={onValidate}
            modalType={ReferenceModalTypes.ROAD_SECTION_EDIT_GESTIONARY}
            options={{ notDismissableByClickingOnBackground: true }}
        >
            <ContentContainer>
                <ModalTitle>{t('reference.modals.editGestionary')}</ModalTitle>
                <Input
                    onKeyDown={handleKeyDown}
                    value={gestionaryName}
                    type="text"
                    onChange={(e) => setGestionaryName(e.target.value)}
                    autoFocus
                />
            </ContentContainer>
        </GenericModal>
    );
};

export default EditRoadSectionGestionaryModal;
